module.exports = __webpack_public_path__ + "img/adesis-logo-2.77cb15c8.png";